import type { AnyAction } from "redux";
import { SHOW_SECTIONS_TOOLTIP } from "app/action_types/tracker_action_types";

function getDefaultState() {
    return {
        showSectionsTooltip: false,
    };
}

export function trackerFirstTimeDeleteSection(state = getDefaultState(), action: AnyAction) {
    switch (action.type) {
        case SHOW_SECTIONS_TOOLTIP: {
            return {
                showSectionsTooltip: action.data,
            };
        }
        default:
            return state;
    }
}
